import { useState } from 'react';
import { Upload } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { SynonymsUploadWizard } from '../../organizations/components/upload-contexts/synonyms';

export function ImportSynonymsDialog() {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline">
          <Upload className="mr-2 h-4 w-4" />
          Import CSV
        </Button>
      </DialogTrigger>
      <DialogContent className="flex h-4/5 min-w-[85%] flex-col">
        <DialogHeader className="mb-0 space-y-0">
          <DialogTitle>Import synonym mappings</DialogTitle>
          <DialogDescription>
            Bulk-create global synonym mappings from a CSV file.
          </DialogDescription>
        </DialogHeader>
        <SynonymsUploadWizard />
      </DialogContent>
    </Dialog>
  );
}
